import { render } from "./BarCodeValidate.vue?vue&type=template&id=3c33a7b5&scoped=true&ts=true"
import script from "./BarCodeValidate.vue?vue&type=script&lang=ts"
export * from "./BarCodeValidate.vue?vue&type=script&lang=ts"

import "./BarCodeValidate.vue?vue&type=style&index=0&id=3c33a7b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c33a7b5"]])

export default __exports__